import { CSSProperties } from 'react';
import { AdminHeaderTitleView } from '@vivli/shared/views';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';

const containerStyle: CSSProperties = {
    marginTop: 35,
};

export const PortalTitleComponent = () => {
    const config = useAppConfigContext();

    return (
        <div style={containerStyle}>
            <AdminHeaderTitleView title={config?.portalTitle} />
        </div>
    );
};
